import { Switch } from 'react-router-dom'

import { RoleAccessManagement } from '../staticRoleManagement'
import { LocalizedRoute } from './localizedRoutes'

export default function PanelRoutes() {
  return (
    <Switch>
      {RoleAccessManagement.map((singleRoute) => (
        <LocalizedRoute
          key={singleRoute.route}
          path={singleRoute.route}
          exact={singleRoute.exact}
          component={singleRoute.component}
        />
      ))}
    </Switch>
  )
}
